import { css } from 'lit';
export const styles = css`.c-icon{width:80px;height:80px;display:grid;place-items:center}.c-icon img{width:80px;height:80px}@media(max-width: 480px){.c-icon{width:56px;height:56px}.c-icon img{width:56px;height:56px}}`;
